<style lang="postcss">
	.toc-aside {
		font-size: 0.875rem;
	}
	.toc-aside .title {
		font-weight: 600;
		margin-bottom: 0.25rem;
	}
	.toc-aside ol {
		padding: 0;
		margin: 0;
		width: 100%;
	}
	.toc-aside li {
		padding: 0;
		margin: 0;
		width: 100%;
		display: block;
	}
	.toc-aside li a {
		color: #6e727a;
		text-decoration: none;
		width: 100%;
		display: block;
	}
	.toc-aside li a:hover {
		color: #333;
	}
	.toc-aside .level-1 {
		margin: 0;
		padding: 0 0 0 0.8rem;
		list-style-type: none;
		position: relative;
	}
	.toc-aside .level-2 {
		margin: 0;
		padding: 0 0 0 0.8rem;
		list-style-type: none;
	}
	.toc-aside .level-1::before {
		content: "";
		width: 2px;
		border-radius: 5px;
		background-color: #d6dbe3;
		position: absolute;
		top: 4px;
		left: 2px;
		bottom: 4px;
	}
</style>

<script lang="ts">
	import { PUBLIC_SITE_URL } from "$env/static/public";

	export let data;
</script>

<svelte:head>
	<title>
		{data.seo_title}
	</title>
	{#if data.post.seo_description}
		<meta name="description" content="{data.post.seo_description}" />
	{/if}
	<link
		rel="canonical"
		href="{PUBLIC_SITE_URL}/help/{data.category}/{data.post.slug}" />
</svelte:head>

<div
	class="prose prose-a:font-normal prose-h1:font-bold prose-h3:mt-10 prose-h2:mt-20">
	<h1 class="text-3xl md:text-4xl md:mb-8 text-balance">
		{data.post.title}
	</h1>

	{#if data.post.links && data.post.links.length > 1}
		<aside class="toc-aside">
			<nav>
				<div class="title">On this page</div>
				<ol class="level-1">
					{#each data.table_of_contents as entry}
						<li>
							<a href="#{entry.value}">{entry.label}</a>
							{#if entry.sub.length}
								<ol class="level-2">
									{#each entry.sub as subEntry}
										<li>
											<a href="#{subEntry.value}">{subEntry.label}</a>
										</li>
									{/each}
								</ol>
							{/if}
						</li>
					{/each}
				</ol>
			</nav>
		</aside>
	{/if}

	{@html data.post.html}

	{#if data.updated_at}
		<div class="text-gray-500 text-sm italic mt-24">
			Last updated on
			<time class="" datetime="{data.post.updated_at}">
				{data.updated_at}
			</time>
		</div>
	{/if}
</div>
